// preact/debug will be replaced with public/src/emptyModule in production
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as preactDebug from "preact/debug";

import Backbone from "backbone";
import * as _ from "underscore";

import * as analytics from "analytics";
import backboneSync from "backboneSync";
import * as deviceDetect from "deviceDetect";
import * as internalLinkHandler from "internalLinkHandler";
import * as jobAd from "jobAd";
import $ from "jquery";
import * as mainLayout from "mainLayout";
import UserModel from "models/UserModel";
import models from "models/models";
import AdminChatsPage from "pages/AdminChatsPage";
import AdminCouponsPage from "pages/AdminCouponsPage";
import AdminPage from "pages/AdminPage";
import AdminUsersPage from "pages/AdminUsersPage";
import AudioUploadedPageView from "pages/AudioUploadedPageView";
import ChatListPageView from "pages/ChatListPageView";
import ChatPageView from "pages/ChatPageView";
import CheckoutPageView from "pages/CheckoutPageView";
import DashboardPageView from "pages/DashboardPageView";
import GenericPage from "pages/GenericPage";
import HeatMapProgressPageView from "pages/HeatMapProgressPageView";
import ImportWordsPageView from "pages/ImportWordsPageView";
import LearnPageView from "pages/LearnPageView";
import PracticePageView from "pages/PracticePageView";
import PreactPage from "pages/PreactPage";
import SettingsPageView from "pages/SettingsPageView";
import StoryBotPageView from "pages/StoryBotPageView";
import WebReaderPage from "pages/WebReaderPage";
import * as accountPage from "pages/accountPage";
import * as accountRenewalPage from "pages/accountRenewalPage";
import * as flashcardsPage from "pages/flashcardsPage";
import * as libraryPage from "pages/libraryPage";
import * as publicShelfPage from "pages/publicShelfPage";
import * as readerPage from "pages/readerPage";
import * as readerReviewPage from "pages/readerReviewPage";
import * as upgradedPage from "pages/upgradedPage";
import * as uploadPage from "pages/uploadPage";
import * as userPage from "pages/userPage";
import * as webReaderSignInPage from "pages/webReaderSignInPage";
import * as wordsPage from "pages/wordsPage";
import readlangClient from "readlangClient";
import * as readlangLocalStorage from "readlangLocalStorage";
import * as dateUtils from "shared/dateUtils";
import * as languageMap from "shared/languageMap";
import * as signupModal from "signupModal";
import * as splitTest from "splitTest";
import StartPageView from "views/StartPageView";
import * as walkthrough from "walkthrough";

// Undo jquery's setting of zoom=1 on iOS
if (navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
  $(document).ready(() => {
    $(document.body).css("zoom", "");
  });
}

Backbone.$ = (window as any).$;

// @ts-ignore
// eslint-disable-next-line no-import-assign
Backbone.sync = backboneSync;

analytics.setup();

const setLoggedInEmail = () => {
  if (models.user.has("email")) {
    readlangLocalStorage.setItem("loggedInEmail", models.user.get("email"));
  } else {
    readlangLocalStorage.removeItem("loggedInEmail");
  }
};

const syncUserId = () => {
  if (models.user.id !== "local" && models.user.id !== window.READLANG.userID) {
    // Set window.READLANG.userID to be the new user ID fetched from the server
    window.READLANG.userID = String(models.user.id);
  }
};

models.user.on("change:email", setLoggedInEmail);
models.user.on("sync", setLoggedInEmail);
models.user.on("changeId", syncUserId);

readlangClient.setUserModel(models.user);
readlangClient.setSignupModal(signupModal);

const DEBUG_MODE = false;
if (DEBUG_MODE) {
  // This doesn't work on android browser (android 2.3.5)
  window.onerror = (error, url, line) => {
    alert(error + "\n\nURL: " + url + "\nline: " + line);
  };
}

const updateCurrentLanguage = (language) => {
  if (language) {
    models.user.save({ currentLearningLanguage: language }, { patch: true });
  }
};

let lastUserFetchTime: number | undefined;
const timeToWaitBetweenUserFetches = 5 * dateUtils.MINUTE;

const AppRouter = Backbone.Router.extend({
  routes: {
    "": "rootPath",
    flashcards: "flashcards",
    ":language/flashcards/book/:bookID": "flashcardsFromBook",
    ":language/flashcards/word/:userWordIDs": "flashcardsFromWords",

    // New practice session
    practice: "practice",
    "practice/book/:bookID": "practiceFromBook",
    "practice/words/:userWordIDs": "practiceFromWords",

    // Remove these after May 2024 - for backwards compatibility with old links. Change happened
    // on 1st March 2024
    ":language/learn/book/:bookID": "flashcardsFromBook",
    ":language/learn/word/:userWordIDs": "flashcardsFromWords",

    learn: "learn",

    dashboard: "dashboard",
    ":language/dashboard": "dashboard",

    library: "publicLibrary",
    ":language/library": "publicLibrary",
    "regenerate/:language/library": "publicLibrary",

    ":language/bookshelf": "privateLibrary",
    ":language/bookshelf/:bookID": "privateLibrary",

    myTexts: "privateLibraryQueue",
    ":language/myTexts": "privateLibraryQueue",

    "myTexts/:tag": "privateLibraryTag",
    ":language/myTexts/:tag": "privateLibraryTag",

    ":language/myTexts/shelf/:shelfID": "privateLibraryShelf",
    "myTexts/shelf/:shelfID": "privateLibraryShelf",

    "shelf/:shelfID": "publicShelf",
    "regenerate/shelf/:shelfID": "publicShelf",

    links: "popularDomains",
    ":language/links": "popularDomains",
    "regenerate/:language/links": "popularDomains",

    "regenerate/library/:bookID": "reader",
    "library/:bookID": "reader",
    "library/:bookID/review/:returnPosition/:position": "readerReview",

    "library/:bookID/end": "reader",
    "library/:bookID/:positionType": "reader",
    "library/:bookID/:positionType/:position": "reader",
    storyBot: "storyBot",

    importWords: "importWords",

    previousHome: "previousHome",
    previousLibraryOrDashboard: "previousLibraryOrDashboard",

    "addDocument?:queryString": "addDocument",
    login: "login",
    words: "words",
    user: "currentUser",
    signup: "signup",
    attributions: "attributions",
    settings: "settings",
    test: "test",
    admin: "adminPage",
    "admin/coupons": "adminCouponsPage",
    "admin/users": "adminUsersPage",
    "admin/chats": "adminChatsPage",
    account: "account",
    accountRenew: "accountRenew",
    "user/:userID": "user",
    "user/:userID/texts/:language": "user",
    "regenerate/user/:userID": "user",
    "regenerate/user/:userID/texts/:language": "user",
    languages: "languages",
    webReader: "webReader",
    webReaderSignIn: "webReaderSignIn",
    checkout: "checkout",
    chat: "chatList",
    "chat/start": "chatStart",
    "chat/:userChatID": "chat",

    upload: "upload",
    audioUploaded: "audioUploaded",

    progress: "progress",

    upgraded: "upgradedPage",

    start: "start",
    "startLanguage/:language": "startLanguage",

    chromeAppStart: "chromeAppStart",
    "chromeAppStart/:language": "chromeAppStart",
    "*anything": "notFound",
  },
  // called before each route to be executed...
  execute: function (callback, args) {
    if (
      models.user.isNew() ||
      Date.now() - (lastUserFetchTime || 0) > timeToWaitBetweenUserFetches
    ) {
      models.user.fetch({
        success: async () => {
          lastUserFetchTime = Date.now();
          syncUserId();

          jobAd.showJobAdIfAppropriate(models.user.toJSON());

          // Stuff to do after fetching user
          models.storedNotifications.fetchAndSetup();

          if (deviceDetect.isStandalone()) {
            walkthrough.setAchievement("standalone", true);
          }

          const couponToken = localStorage?.getItem("couponToken");

          if (couponToken && !(await readlangClient.isLocalMode())) {
            localStorage.removeItem("couponToken");

            readlangClient.request(
              "POST",
              `/api/coupon/redeemToken/${couponToken}`,
              { couponToken },
              () => {
                // Success
                window.location.pathname = "/upgraded";
              }
            );
          }

          callback.apply(this, args);
        },
      });
    } else {
      callback.apply(this, args);
    }
  },
  start: function () {
    mainLayout.renderPage(
      new PreactPage({
        name: "startPage",
        showHeader: false,
        Child: StartPageView,
      })
    );
  },
  startLanguage: function (language) {
    if (!languageMap.map[language]) {
      this._notFound();
      return;
    }
    mainLayout.renderPage(
      new PreactPage({
        name: "startPage",
        showHeader: false,
        Child: StartPageView,
      }),
      {
        learningLanguage: language,
      }
    );
  },
  rootPath: function () {
    this._notFound();
  },
  previousHome: async function () {
    let homePath = localStorage.getItem("homePath");
    if (await readlangClient.isLocalMode()) {
      homePath = "library";
    }
    appRouter.navigate(homePath || "/library", {
      trigger: true,
      replace: true,
    });
  },
  previousLibraryOrDashboard: function () {
    appRouter.navigate(
      localStorage.getItem("libraryOrDashboardPath") || "/dashboard",
      { trigger: true, replace: true }
    );
  },
  popularDomains: function (language) {
    updateCurrentLanguage(language);
    appRouter.navigate(
      "/" + models.user.get("currentLearningLanguage") + "/links",
      { replace: true }
    );
    mainLayout.renderPage(libraryPage, {
      tab: "popularDomains",
      language: language,
    });
  },
  privateLibraryQueue: function (language) {
    updateCurrentLanguage(language);
    appRouter.navigate(
      "/" + models.user.get("currentLearningLanguage") + "/myTexts/previous",
      { trigger: true, replace: true }
    );
  },
  privateLibrary: function (language, bookID) {
    mainLayout.renderPage(libraryPage, {
      tab: "privateTexts",
      language: language,
      bookID: bookID,
    });
  },
  privateLibraryTag: function (language, tag) {
    if (!tag) {
      tag = language;
      language = undefined;
    }
    updateCurrentLanguage(language);
    appRouter.navigate(
      "/" + models.user.get("currentLearningLanguage") + "/myTexts/" + tag,
      { replace: true }
    );
    mainLayout.renderPage(libraryPage, {
      tab: "privateTexts",
      tag: tag !== "previous" && tag,
    });
  },
  privateLibraryShelf: function (language, shelfID) {
    if (!shelfID) {
      shelfID = language;
      language = undefined;
    }
    updateCurrentLanguage(language);
    appRouter.navigate(
      "/" +
        models.user.get("currentLearningLanguage") +
        "/myTexts/shelf/" +
        shelfID,
      { replace: true }
    );

    mainLayout.renderPage(libraryPage, {
      tab: "privateTexts",
      shelfID: shelfID,
    });
  },
  publicLibrary: function (language) {
    updateCurrentLanguage(language);
    appRouter.navigate(
      "/" + models.user.get("currentLearningLanguage") + "/library",
      { replace: true }
    );
    mainLayout.renderPage(libraryPage, {
      tab: "publicTexts",
      skipOnboardingDialogs: true,
    });
  },
  publicShelf: function (shelfID) {
    mainLayout.renderPage(publicShelfPage, {
      shelfID,
      skipOnboardingDialogs: true,
    });
  },
  reader: function (bookID, positionType, position) {
    const options: any = {
      bookID: bookID,
      skipOnboardingDialogs: true,
    };
    if (positionType === "from") {
      options.from = position;
    } else if (positionType === "to") {
      options.to = position;
    } else if (positionType === "scroll") {
      options.scroll = position || 0;
    }
    mainLayout.renderPage(readerPage, options);
  },
  readerReview: function (bookID, returnPosition, position) {
    mainLayout.renderPage(readerReviewPage, {
      bookID: bookID,
      position: parseInt(position, 10),
      returnPosition: parseInt(returnPosition, 10),
    });
  },
  flashcards: function () {
    mainLayout.renderPage(flashcardsPage);
  },
  flashcardsFromWords: function (language, userWordIDs) {
    mainLayout.renderPage(flashcardsPage, {
      language,
      userWordIDs,
    });
  },
  flashcardsFromBook: function (language, chosenBookID) {
    mainLayout.renderPage(flashcardsPage, {
      language,
      chosenBookID,
    });
  },
  learn: function () {
    if (models.flashcardSession?.inProgress()) {
      // User is mid-session, redirect to flashcards instead
      appRouter.navigate("/flashcards", { trigger: true, replace: true });
      return;
    }

    mainLayout.renderPage(
      new PreactPage({
        name: "learnPage",
        showHeader: true,
        Child: LearnPageView,
      })
    );
  },
  practice: function () {
    mainLayout.renderPage(
      new PreactPage({
        name: "practicePage",
        showHeader: false,
        Child: PracticePageView as any,
      })
    );
  },
  progress: function () {
    mainLayout.renderPage(
      new PreactPage({
        name: "progressPage",
        showHeader: true,
        Child: HeatMapProgressPageView as any,
      })
    );
  },
  practiceFromBook: function (bookID) {
    mainLayout.renderPage(
      new PreactPage({
        name: "practicePage",
        showHeader: false,
        Child: PracticePageView as any,
      }),
      { bookID }
    );
  },
  practiceFromWords: function (userWordIDs) {
    mainLayout.renderPage(
      new PreactPage({
        name: "practicePage",
        showHeader: false,
        Child: PracticePageView as any,
      }),
      { userWordIDs: userWordIDs.split("|") }
    );
  },
  login: async function () {
    readlangClient.login();
  },
  words: function () {
    mainLayout.renderPage(wordsPage);
  },
  dashboard: function (language) {
    updateCurrentLanguage(language);
    appRouter.navigate(
      "/" + models.user.get("currentLearningLanguage") + "/dashboard",
      { replace: true }
    );
    mainLayout.renderPage(
      new PreactPage({
        name: "dashboardPage",
        showHeader: true,
        Child: DashboardPageView,
      })
    );
  },
  currentUser: function () {
    const user = new UserModel();
    user.fetch({
      success: () => {
        $("body").html("fetched user = " + JSON.stringify(user));
      },
    });
  },
  settings: async function () {
    if (await readlangClient.isLocalMode()) {
      readlangClient.login();
      return;
    }

    mainLayout.renderPage(
      new PreactPage({
        name: "settingsPage",
        showHeader: true,
        Child: SettingsPageView,
      })
    );
  },
  storyBot: async function () {
    mainLayout.renderPage(
      new PreactPage({
        name: "storyBot",
        showHeader: true,
        Child: StoryBotPageView,
      })
    );
  },
  adminPage: function () {
    if (!models.user.isGod()) {
      this._notFound();
      return;
    }

    mainLayout.renderPage(
      new PreactPage({
        name: "adminPage",
        showHeader: true,
        Child: AdminPage,
      })
    );
  },
  adminCouponsPage: function () {
    if (!models.user.isGod()) {
      this._notFound();
      return;
    }

    mainLayout.renderPage(
      new PreactPage({
        name: "adminCouponPage",
        showHeader: true,
        Child: AdminCouponsPage,
      })
    );
  },
  adminUsersPage: function () {
    if (!models.user.isGod()) {
      this._notFound();
      return;
    }

    mainLayout.renderPage(
      new PreactPage({
        name: "adminUsersPage",
        showHeader: true,
        Child: AdminUsersPage,
      })
    );
  },
  adminChatsPage: function () {
    if (!models.user.isGod()) {
      this._notFound();
      return;
    }

    mainLayout.renderPage(
      new PreactPage({
        name: "adminChatsPage",
        showHeader: true,
        Child: AdminChatsPage,
      })
    );
  },
  chromeAppStart: function () {
    localStorage.setItem("referrer", "chromeApp");
    this._notFound();
  },
  notFound: function () {
    this._notFound();
  },
  _notFound: function () {
    appRouter.navigate("/dashboard", { replace: true, trigger: true });
  },
  attributions: function () {
    mainLayout.renderPage(new GenericPage("attributions", "attributions"));
  },
  languages: function () {
    readlangClient.request("GET", "/api/languages", {}, (languagesData) => {
      languagesData.languages = _.sortBy(languagesData.languages, "name");
      languagesData.numLanguages = languagesData.languages.length;
      mainLayout.renderPage(
        new GenericPage("languages", "languages", {
          templateData: languagesData,
        })
      );
    });
  },
  checkout: function () {
    mainLayout.renderPage(
      new PreactPage({
        name: "checkout2Page",
        showHeader: false,
        Child: CheckoutPageView,
      })
    );
    splitTest.trackEvent("openCheckout");
  },
  user: function (userID, language) {
    mainLayout.renderPage(userPage, { userID: userID, language: language });
  },
  upgradedPage: function () {
    mainLayout.renderPage(upgradedPage);
  },
  webReader: function () {
    mainLayout.renderPage(new WebReaderPage());
  },
  account: function () {
    mainLayout.renderPage(accountPage);
  },
  accountRenew: function () {
    mainLayout.renderPage(accountRenewalPage);
  },
  upload: function () {
    mainLayout.renderPage(uploadPage);
  },
  audioUploaded: function () {
    mainLayout.renderPage(
      new PreactPage({
        name: "audioUploadedPage",
        showHeader: true,
        Child: AudioUploadedPageView,
      })
    );
  },
  webReaderSignIn: function () {
    console.log("web reader sign in page");
    mainLayout.renderPage(webReaderSignInPage);
  },
  importWords: function () {
    mainLayout.renderPage(
      new PreactPage({
        name: "importWordsPage",
        showHeader: true,
        Child: ImportWordsPageView,
      })
    );
  },
  chatStart: function () {
    const urlParams = new URLSearchParams(window.location.search);
    mainLayout.renderPage(
      new PreactPage({
        name: "chatPage",
        showHeader: false,
        Child: ChatPageView,
      }),
      {
        start: true,
        initialMessageID: urlParams.get("initialMessageID"),
      }
    );
  },
  chat: function (userChatID: string) {
    mainLayout.renderPage(
      new PreactPage({
        name: "chatPage",
        showHeader: false,
        Child: ChatPageView,
      }),
      { userChatID }
    );
  },
  chatList: function () {
    mainLayout.renderPage(
      new PreactPage({
        name: "chatListPage",
        showHeader: true,
        Child: ChatListPageView,
      })
    );
  },
});

export const appRouter = new AppRouter();

readlangClient.fetchAuthenticatedState(() => {
  mainLayout.init(appRouter);

  Backbone.history.start({
    pushState: true,
  });

  // Use router for all links, except if they have data-bypass attribute
  internalLinkHandler.setup($(document), appRouter);
});
